import { render } from "./SearchNote.vue?vue&type=template&id=2f1dba60"
import script from "./SearchNote.vue?vue&type=script&lang=js"
export * from "./SearchNote.vue?vue&type=script&lang=js"
script.render = render

export default script